export function referentMedics(medicsByHealthCentres) {
  return medicsByHealthCentres.flatMap(medicsByHealthCentre => {
    return medicsByHealthCentre.medics.filter(m => m.isReferent);
  });
}
